<template>
    <div class="d-flex justify-content-center align-items-center flex-column pt-10 gap-3" v-if="changedName == false">
        <h1>Je zit bij knop{{ button }}!</h1>
        <h2>Wat is je naam</h2>
        <input class="w-50 form-control" style="background-color: #F2F2F2;" type="text" placeholder="naam" v-model="name">
        <button class="w-50 btn btn-secondary text-dark text-uppercase mt-3" @click="changeName">submit</button>
    </div>
    
    <div class="text-center pt-10 gap-3" v-else>
        <h1>Bedankt voor het invullen van je naam!</h1>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import axios from "axios";

const changedName = ref(false);
const name = ref(null);
const button = ref(null);

onMounted(() => {
    button.value = getButtonNumber();
})

function changeName(){
    changedName.value = true;
    axios.post("/api/editName", {"number": button.value, "name": name.value});
}

function getButtonNumber(){
    const queryString = window.location.search;

    const buttonValue = new URLSearchParams(queryString).get("button");

    return buttonValue;
}
</script>
